import type { IPermission } from '@manager/types/permission-types';
import { defineStore } from 'pinia';

export interface IPermissionStoreModel {
  permissions: IPermission[] | null;
}

export const usePermissionStore = defineStore('permissions', {
  state: () =>
    ({
      permissions: null,
    }) as IPermissionStoreModel,
  actions: {
    async reset() {
      this.permissions = null;
    },
  },
  persist: true,
});
